/**
 * How a measuring unit is named on screen, and what a product line's quantity
 * is counted in. ONE rule, read by every screen that shows a unit, so no screen
 * can drift to its own choice again.
 *
 * It drifted before: the enquiry and recap cards showed a unit's description,
 * the delivery showed its name, the invoice reader showed "code - name". On the
 * live unit list the description is not a name at all -- it is a capacity in
 * litres ("209 liters" for DRUM - 209 LTR, and "180 liters" for a pack whose
 * name says DRUM - 180 KG) -- so a trader picking a pack was shown a litre
 * conversion instead of the pack.
 */

/** The text a person sees for a unit: its name ("DRUM - 209 LTR"). */
export const unitLabel = (unit) => {
  if (!unit) return '';
  return unit.name || unit.code || '';
};

/** The unit with this id in a unit list, or null. */
export const findUnit = (units, id) => {
  if (id === null || id === undefined || id === '') return null;
  return (units || []).find((u) => String(u.id) === String(id)) || null;
};

/** True for a product line selling lubricants rather than marine fuel. */
export const isLubesLine = (line) => (line?.product_kind || 'bunkers') === 'lubes';

/**
 * What a product line's quantity -- and so every price and commission rate on
 * it -- is counted in, as the words a person reads.
 *
 * - Lubes: the line's own measuring unit ("DRUM - 209 LTR"); '' until picked.
 * - Bunkers: metric tonnes whatever the unit box shows. The bunkers card has
 *   always said so, and bunkers stays exactly as it was.
 *
 * Mirrors ``conversion_service.quantity_unit`` on the server, which carries the
 * same answer onto the recap.
 */
export const lineQuantityUnit = (line, units) => (
  isLubesLine(line) ? unitLabel(findUnit(units, line?.measuring_unit)) : 'mt'
);

/**
 * A money label counted per unit: "Sell Price ($/mt)" on a fuel line,
 * "Sell Price ($/DRUM - 209 LTR)" on a drum deal, and "Sell Price ($ per unit)"
 * on a lubes line whose unit has not been picked yet.
 */
export const perUnitLabel = (name, currency, unitText) => (
  unitText ? `${name} (${currency}/${unitText})` : `${name} (${currency} per unit)`
);
